import { Button, Col, Row } from 'reactstrap';
import React, { useEffect, useState, useMemo, useContext } from 'react';
import {
  FormattedDate,
  FormattedMessage,
  FormattedNumber,
  useIntl,
} from 'react-intl';
import {
  extractOrderTaxesByType,
  capitalize,
  getNextOrderStatus,
  calculateAgoSeconds,
  replaceColorInLottie,
  getOrderPathType,
  getLocalizedOrderHint,
  getBrowserLocale,
  extractTextOrNull,
} from '../../../../utility/util/util.service';
import classnames from 'classnames';
import ModalSheet from '../modal-sheet/modal-sheet.component';
import { connect } from 'react-redux';
import {
  setIsOrderInfoModalOpen,
  setOrderInfoModalData,
  setIsCreateBillingAddressModalOpen,
  setCreateBillingAddressModalData,
  setIsSelectBillingAddressModalOpen,
  setIsTableCartModalOpen,
  setIsOrderNotificationsModalOpen,
  setOrderHintModalData,
  setIsOrderHintModalOpen,
} from '../../../../redux/modal/modal.actions';
import {
  CHECKOUT_METHOD_PAY_AND_GO,
  CHECKOUT_METHOD_ORDER_ONLY,
  ORDER_STATUS_COMPLETED,
  ORDER_TYPE_DELIVERY,
  ORDER_TYPE_INHOUSE,
  ORDER_TYPE_PICKUP,
  ORDER_STATUS_PENDING,
  ORDER_TYPE_SELF_SERVICE,
  ORDER_TYPE_CATERING,
  ORDER_STATUS_PREPARING,
  ORDER_STATUS_PREPARED,
  ORDER_STATUS_DELIVERING,
} from '../../../../utility/constants';
import SkeletonLoader from '../../lazyload/skeleton-loader/skeleton-loader.component';
import {
  customMessageNotification,
  notification,
} from '../../../../utility/notification/notification.service';
import {
  basePatchQuery,
  basePostQuery,
  createGuest,
  getStoreOrder,
} from '../../../../utility/sb-api/sb-api.service';
import {
  fetchStoreOrders,
  setStoreSpecificOrder,
} from '../../../../redux/store/store.actions';
import { getAdminButtonText, isPendingOrderStatus } from './order-info.service';
import { useHistory, useLocation } from 'react-router-dom';
import QRCode from 'react-qr-code';
import success1 from '../../../../assets/lottie/success-1.json';
import success2 from '../../../../assets/lottie/success-2.json';
import success3 from '../../../../assets/lottie/success-3.json';
import Lottie from 'lottie-react';
import { getOrder } from '../../../../utility/sb-api/sb-api.service';
import {
  fetchMe,
  fetchMeWithPromise,
  fetchOnAuthenticated,
  fetchOrders,
  setFoodAllergensFilter,
  setFoodIngredientsFilter,
  setFoodPreferencesFilter,
  setSpecificOrder,
} from '../../../../redux/me/me.actions';
import Marquee from '../../helpers/marquee.component';
import OrderItemLine from '../cart/order-item-line.component';
import { SwipeableButton } from 'react-swipeable-button';
import { SocketContext } from '../../../../context/socket.context';
import DefaultAlert from '../../alerts/default-alert/default-alert.component';
import xss from 'xss';
import { IntlContext } from '../../../../context/intl.context';
import { DateTime } from 'luxon';
import { config } from '../../../../configs/app.config';

const OrderInfoModal = ({
  isOpen,
  data, // {order: Order, isInitial: boolean, isAdminMode: boolean}
  userOrders,
  storeOrders,
  store,
  billingAddresses,
  tableCart,
  kiosk,
  me,

  setIsOrderInfoModalOpen,
  setIsCreateBillingAddressModalOpen,
  setIsSelectBillingAddressModalOpen,
  setCreateBillingAddressModalData,
  setIsTableCartModalOpen,
  setSpecificOrder,
  setStoreSpecificOrder,
  fetchOnAuthenticated,
  fetchOrders,
  setFoodPreferencesFilter,
  setFoodIngredientsFilter,
  setFoodAllergensFilter,
  setIsOrderNotificationsModalOpen,
  fetchMeWithPromise,
  setOrderHintModalData,
  setIsOrderHintModalOpen,
}) => {
  const intl = useIntl();
  const [order, setOrder] = useState(null);
  const [animationFinished, setAnimationFinished] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isAdminMode = !!data?.isAdminMode;
  const history = useHistory();
  const { search } = useLocation();
  const [isUpdating, setIsUpdating] = useState(false);
  const [
    isInitialOrderNotificationsModalOpen,
    setIsInitialOrderNotificationsModalOpen,
  ] = useState(true);
  const [
    isInitialOrderHintModalOpen,
    setIsInitialOrderHintModalOpen,
  ] = useState(true);
  const socketContext = useContext(SocketContext);
  const [isInitial, setIsInitial] = useState(false);

  // find the order by given order.id
  useEffect(() => {
    if (isOpen) {
      const targetOrders = isAdminMode ? storeOrders : userOrders;

      if (targetOrders && data?.order) {
        const foundOrder = targetOrders?.find(
          ({ id }) => id === data.order?.id,
        );
        setOrder(foundOrder || data?.order || null);
      } else {
        notification('error', 'defaultUnknownError');
      }
    } else {
      setOrder(null); // cleanup after close
      setAnimationFinished(false);
      //setOrderInfoModalData(null, null)
    }
  }, [userOrders, storeOrders, data, isOpen, order]);

  useEffect(() => {
    if (data) {
      setIsInitial(data?.isInitial);
    }
  }, [data]);

  useEffect(() => {
    if (kiosk && isInitial) {
      const timeoutId = setTimeout(
        () => {
          closeModal();
          history.push(`/store/${store?.slug}`);
        },
        config.env === 'staging' ? 10000 : 20000,
      ); // 10 seconds

      return () => clearTimeout(timeoutId);
    }
  }, [kiosk, isInitial]);

  // changes order status to the well-defined next status
  const handleChangeOrderStatus = () => {
    setIsSubmitting(true);
    const nextStatus = getNextOrderStatus(status, type);
    basePatchQuery(`orders/${id}/store`, {
      status: nextStatus,
    })
      .then(() => {
        setIsSubmitting(false);
        notification('success', 'changesSaved');
        setOrder(null);
      })
      .catch(() => {
        setIsSubmitting(false);
        notification('error', 'changesSavedError');
        setOrder(null);
      });
  };

  const handleOrderCompleted = () => {
    setIsSubmitting(true);
    basePatchQuery(`orders/${getOrderPathType(type)}/${id}`, {
      status: ORDER_STATUS_COMPLETED,
    })
      .then(() => {
        setIsSubmitting(false);
        notification('success', 'changesSaved');
      })
      .catch(() => {
        setIsSubmitting(false);
        notification('error', 'changesSavedError');
      });
  };

  const handleNotifyStore = () => {
    setIsSubmitting(true);
    basePostQuery(`orders/${getOrderPathType(type)}/${id}/i-am-here`)
      .then(() => {
        setIsSubmitting(false);
        customMessageNotification(
          'success',
          intl.formatMessage(
            { id: 'storeNotifiedByUser' },
            { storeName: store?.name },
          ),
        );
      })
      .catch(() => {
        setIsSubmitting(false);
        notification('error', 'changesSavedError');
      });
  };

  const handleSendInvoice = () => {
    if (billingAddresses.length > 0) {
      setIsSelectBillingAddressModalOpen(true);
    } else {
      setCreateBillingAddressModalData({ openedFromOrderInfo: true });
      setIsCreateBillingAddressModalOpen(true);
    }
  };

  const setExpectedMinutes = (time) => {
    const patchRequest = (timeObj) => {
      basePatchQuery(`orders/${id}/store`, {
        ...timeObj,
      })
        .then(() => {
          setIsOrderInfoModalOpen(false);
          setIsSubmitting(false);
          notification('success', 'changesSaved');
          setOrder(null);
        })
        .catch(() => {
          setIsSubmitting(false);
          notification('error', 'changesSavedError');
          setOrder(null);
        });
    };

    setIsSubmitting(true);

    if (type === ORDER_TYPE_PICKUP) {
      let pickupConfirmedAt;
      if (pickupRequestedAt) {
        pickupConfirmedAt = new Date(pickupRequestedAt);
        pickupConfirmedAt.setMinutes(
          new Date(pickupRequestedAt).getMinutes() + time,
        );
      } else {
        pickupConfirmedAt = new Date();
        pickupConfirmedAt.setMinutes(pickupConfirmedAt.getMinutes() + time);
      }
      patchRequest({ pickupConfirmedAt: pickupConfirmedAt.toISOString() });
    }

    if (type === ORDER_TYPE_DELIVERY) {
      const deliveryConfirmedAt = new Date();
      deliveryConfirmedAt.setMinutes(deliveryConfirmedAt?.getMinutes() + time);
      patchRequest({ deliveryConfirmedAt: deliveryConfirmedAt.toISOString() });
    }
  };

  const {
    id,
    cartComment,
    deliveryAddress,
    deliveryFee,
    serviceFee,
    number,
    total,
    merchantProfile,
    customerProfile,
    billingAddress,
    payment,
    items,
    tip,
    status,
    table,
    statusPreparingAt,
    createdAt,
    updatedAt,
    type,
    statusPaidAt,
    checkoutMethod,
    invoiceNumber,
    customerName,
    customerTel,
    customerEmail,
    customFields,
    readyToPickupAt,
    pickupConfirmedAt,
    pickupRequestedAt,
    deliveryConfirmedAt,
    iAmHereNotificationAt,
    discountCode,
    discount,
  } = order || {};
  const deliveryAddressDescriptor = [
    deliveryAddress?.companyName ||
      [deliveryAddress?.firstName, deliveryAddress?.lastName].join(' '),
    deliveryAddress?.tel,
    deliveryAddress?.line1,
    deliveryAddress?.line2,
    [deliveryAddress?.zip, deliveryAddress?.city].join(' '),
  ]
    .filter((part) => !!part)
    .join(', ');
  const billingAddressDescriptor = [
    billingAddress?.companyName ||
      [billingAddress?.firstName, billingAddress?.lastName].join(' '),
    billingAddress?.line1,
    billingAddress?.line2,
    [billingAddress?.zip, billingAddress?.city].join(' '),
  ]
    .filter((part) => !!part)
    .join(', ');
  const isDeliveryOrder = type === ORDER_TYPE_DELIVERY;
  const isPickupOrder = type === ORDER_TYPE_PICKUP;
  const isInhouseOrder = type === ORDER_TYPE_INHOUSE;
  const isCateringOrder = type === ORDER_TYPE_CATERING;
  const isSelfServiceOrder = type === ORDER_TYPE_SELF_SERVICE;
  const taxesByType = extractOrderTaxesByType(order);

  const { switchLocale } = useContext(IntlContext);

  const closeModal = () => {
    if (search) {
      history.replace({ search: null });
    }

    if (kiosk) {
      const browserLocale = getBrowserLocale();
      setFoodPreferencesFilter(null);
      setFoodIngredientsFilter(null);
      setFoodAllergensFilter(null);
      localStorage.removeItem('guestToken');
      socketContext.socket = null;
      createGuest({ locale: intl?.locale }, socketContext?.setToken).then(
        () => {
          fetchOnAuthenticated();
          fetchOrders();
        },
      );
      switchLocale(browserLocale);
    }
    setIsInitialOrderNotificationsModalOpen(true);
    setIsOrderInfoModalOpen(false);
  };
  const statusTimestamp = status && 'status' + capitalize(status) + 'At';
  const statusUpdatedAt =
    statusTimestamp && calculateAgoSeconds(order[statusTimestamp]);

  const smartSchankOrderItemIds =
    checkoutMethod !== CHECKOUT_METHOD_PAY_AND_GO &&
    items
      ?.filter(({ itemData }) => !!itemData?.smartSchankPlu)
      .map(({ id }) => id);

  const smartSchankAccessCode =
    smartSchankOrderItemIds?.length &&
    customFields?.smartSchankPeripheralIntegration?.accessCode;

  const successAnimationFull = useMemo(
    () => (
      <Lottie
        style={{ width: '100%', maxWidth: '250px' }}
        animationData={replaceColorInLottie(
          success3,
          store?.primaryColor || '#22442c',
        )}
        onComplete={() => {
          setIsSubmitting(true);
          setAnimationFinished(true);
          setTimeout(() => setIsSubmitting(false), 1000);
        }}
        loop={false}
      />
    ),
    [store?.primaryColor],
  );

  const successAnimationHeader = useMemo(
    () => (
      <Lottie
        style={{ width: '60px' }}
        className="mr-1"
        rendererSettings={{ viewBoxSize: '200 200 600 600', viewBoxOnly: true }}
        animationData={replaceColorInLottie(
          success2,
          store?.primaryColor || '#22442c',
        )}
        loop={false}
      />
    ),
    [store?.primaryColor],
  );

  const handleUpdateOrder = () => {
    if (!isUpdating) {
      setIsUpdating(true);
      let requestFinished = false;

      // check periodically if fetching is done
      setInterval(() => {
        if (requestFinished) {
          setIsUpdating(false);
          requestFinished = false;
        }
      }, 1000);

      const cb = () => {
        requestFinished = true;
      };
      if (isAdminMode) {
        return getStoreOrder(data?.order?.id)
          .then((fetchedOrder) => {
            setStoreSpecificOrder(fetchedOrder);
            cb();
          })
          .catch(cb);
      } else {
        return getOrder(data?.order?.id)
          .then((fetchedOrder) => {
            setSpecificOrder(fetchedOrder);
            cb();
          })
          .catch(cb);
      }
    } else {
      console.log('Order update is already in progress');
      return Promise.reject();
    }
  };
  const renderAdminButton =
    isAdminMode &&
    order &&
    [
      ORDER_STATUS_PREPARING,
      ORDER_STATUS_PREPARED,
      ORDER_STATUS_DELIVERING,
    ].includes(status) &&
    ((type === ORDER_TYPE_PICKUP
      ? pickupConfirmedAt
      : type === ORDER_TYPE_DELIVERY && deliveryConfirmedAt) ||
      [ORDER_TYPE_SELF_SERVICE].includes(type));

  const renderUserButtons =
    (!billingAddress &&
      checkoutMethod !== CHECKOUT_METHOD_ORDER_ONLY &&
      invoiceNumber) ||
    (isInitial &&
      checkoutMethod === CHECKOUT_METHOD_ORDER_ONLY &&
      tableCart &&
      store?.merchantProfile?.enablePayAndGo);

  const orderHint = isInhouseOrder
    ? store?.merchantProfile?.inhouseOrderHint
    : isPickupOrder
    ? store?.merchantProfile?.pickupOrderHint
    : isDeliveryOrder
    ? store?.merchantProfile?.deliveryOrderHint
    : isCateringOrder
    ? store?.merchantProfile?.cateringOrderHint
    : store?.merchantProfile?.selfServiceOrderHint;

  const customXss = new xss.FilterXSS({
    whiteList: {
      p: [],
      b: [],
      br: [],
      em: [],
      u: [],
      i: [],
      strong: [],
      a: ['href', 'target'],
    },
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      if (
        getLocalizedOrderHint(orderHint, intl.locale) &&
        isInitialOrderHintModalOpen &&
        extractTextOrNull(getLocalizedOrderHint(orderHint, intl.locale))
      ) {
        setIsInitialOrderHintModalOpen(false);
        setOrderHintModalData({
          text: getLocalizedOrderHint(orderHint, intl.locale),
        });
        setIsOrderHintModalOpen(true);
      } else if (
        me?.requester?.customerProfile &&
        isOpen &&
        store?.merchantProfile?.enableCustomerOrderNotifications &&
        !kiosk &&
        (!me?.requester?.customerProfile?.whatsAppPhoneNumber ||
          DateTime.fromISO(
            me?.requester?.customerProfile?.whatsAppConversationExpiresAt,
          ) < DateTime.now()) &&
        !me?.requester?.customerProfile?.smsPhoneNumber &&
        !extractTextOrNull(getLocalizedOrderHint(orderHint, intl.locale))
      ) {
        fetchMeWithPromise().then((me) => {
          if (
            !me?.requester?.customerProfile?.whatsAppPhoneNumber &&
            !me?.requester?.customerProfile?.smsPhoneNumber &&
            isInitialOrderNotificationsModalOpen
          ) {
            setIsOrderNotificationsModalOpen(true);
            setIsInitialOrderNotificationsModalOpen(false);
          }
        });
      }
    }, 5000); // 5 second delay

    return () => clearTimeout(timer); // Cleanup on unmount
  }, [order, customerProfile, isOpen]);

  const SanitizedHTML = ({ htmlContent, wrapperClassName }) => {
    const sanitizedHtml = customXss.process(htmlContent);

    return (
      <div
        className={`${wrapperClassName} no-margin-paragraphs`}
        dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
      />
    );
  };
  return (
    <ModalSheet
      data-testid="orderInfoModal"
      isOpen={isOpen}
      closeModal={closeModal}
      isRefreshing={isUpdating}
      onRefreshHandler={handleUpdateOrder}
      disableEnterToSubmit={true}
      footer={
        (!isInitial || animationFinished || isAdminMode) &&
        (renderAdminButton || renderUserButtons) ? (
          <div className="align-content-center">
            {renderAdminButton && (
              <Button
                color="primary"
                className="btn-block"
                onClick={handleChangeOrderStatus}
              >
                {getAdminButtonText(intl, order)}
              </Button>
            )}
            {!isAdminMode && (
              <div className="d-flex justify-content-around">
                {!billingAddress &&
                  checkoutMethod !== CHECKOUT_METHOD_ORDER_ONLY &&
                  invoiceNumber && (
                    <Button
                      color="primary"
                      className="btn-block"
                      onClick={handleSendInvoice}
                    >
                      <FormattedMessage id="sendInvoiceLabel" />
                    </Button>
                  )}
                {isInitial &&
                  checkoutMethod === CHECKOUT_METHOD_ORDER_ONLY &&
                  tableCart &&
                  store?.merchantProfile?.enablePayAndGo && (
                    <Button
                      data-testid="switchToTableCartButton"
                      color="primary"
                      className="btn-block"
                      onClick={() => setIsTableCartModalOpen(true)}
                    >
                      <FormattedMessage id="switchToTableCartLabel" />
                    </Button>
                  )}
              </div>
            )}
          </div>
        ) : null
      }
      title={
        order ? (
          intl.formatMessage(
            {
              id: isAdminMode
                ? 'orderNumber'
                : checkoutMethod === CHECKOUT_METHOD_PAY_AND_GO
                ? 'yourPaymentAt'
                : 'yourOrderAt',
            },
            {
              invoiceNumber,
              storeName: merchantProfile?.store.name,
              orderNumber: number || (
                <SkeletonLoader inline style={{ width: '70px' }} />
              ),
            },
          )
        ) : (
          <SkeletonLoader style={{ width: '100%' }} />
        )
      }
    >
      {isInitial && !animationFinished ? (
        <div className="d-flex align-content-center justify-content-center">
          {successAnimationFull}
        </div>
      ) : !order || isSubmitting ? (
        // Show Skeleton loaders while Order is not available or submitting
        <div className="d-block px-1">
          {isInitial && (
            <>
              <div className="d-flex">
                <SkeletonLoader className="thumbnail-50" />
                <div
                  className="d-flex flex-column px-1 flex-grow-1 justify-content-between"
                  style={{ minWidth: 0 }}
                >
                  <SkeletonLoader inline className="font-medium-1 w-100" />
                  <SkeletonLoader inline className="font-small-3 w-50" />
                </div>
              </div>
              <hr />
            </>
          )}

          {[1, 2].map((item, index) => (
            <div
              key={index}
              className="d-flex align-items-center justify-content-between mb-1"
            >
              <SkeletonLoader inline className="thumbnail-40" />
              <div
                className="d-flex flex-column px-1 flex-grow-1 justify-content-between"
                style={{ minWidth: 0 }}
              >
                <SkeletonLoader inline className="font-small-3 w-75" />
                <SkeletonLoader inline className="font-small-2 w-50" />
              </div>
              <div className="d-flex flex-column justify-content-between align-items-end">
                <SkeletonLoader
                  inline
                  className="font-medium-3"
                  style={{ width: '60px' }}
                />
              </div>
            </div>
          ))}

          {[
            [0, 0],
            [90, 170],
            [100, 160],
            [0, 0],
            [100, 150],
            [0, 0],
            [90, 100],
            [110, 50],
            [105, 60],
            [40, 80],
            [60, 110],
            [0, 0],
            [80, 60],
            [70, 80],
            [90, 50],
          ].map(([leftWidth, rightWidth], index) =>
            leftWidth + rightWidth > 0 ? (
              <div
                key={index}
                className="d-flex justify-content-between align-items-center"
              >
                <span>
                  <SkeletonLoader inline style={{ width: leftWidth + 'px' }} />
                </span>
                <span>
                  <SkeletonLoader inline style={{ width: rightWidth + 'px' }} />
                </span>
              </div>
            ) : (
              <hr />
            ),
          )}
        </div>
      ) : (
        <>
          {/* Show animated header only once after checkout */}
          {!isAdminMode && isInitial && (
            <div className="px-1">
              <div className="d-flex flex-column align-items-center justify-content-center">
                <div className="d-flex align-items-center justify-content-around">
                  {successAnimationHeader}
                  <div className="d-block text-left font-medium-1 black">
                    <FormattedMessage
                      id={
                        checkoutMethod === CHECKOUT_METHOD_PAY_AND_GO
                          ? 'thankYouForVisitingStore'
                          : 'yourOrderWasSuccessfulAtStore'
                      }
                      values={{ storeName: merchantProfile?.store.name }}
                    />
                  </div>
                </div>
              </div>
              <hr />
            </div>
          )}

          <div className="px-1">
            {merchantProfile?.scannerActionQrCodeType &&
              !isAdminMode &&
              !kiosk &&
              status !== ORDER_STATUS_COMPLETED && (
                <>
                  <div className="d-flex justify-content-center align-items-center py-50">
                    <div className="d-block">
                      {order ? (
                        <QRCode
                          size={130}
                          value={
                            `${merchantProfile?.scannerActionQrCodeType}:` +
                            order.id
                          }
                        />
                      ) : (
                        <SkeletonLoader
                          inline
                          style={{ width: '100px', height: '100px' }}
                        />
                      )}
                    </div>
                    <span className="px-1 ml-2 black font-medium-1">
                      {(order && <FormattedMessage id="scanQrCodeText" />) || (
                        <SkeletonLoader inline style={{ width: '100px' }} />
                      )}
                    </span>
                  </div>
                  <hr />
                </>
              )}
            {/* Show SmartSchank access code */}
            {smartSchankOrderItemIds?.length > 0 &&
              store?.merchantProfile?.peripheralIntegrations.find(
                (integration) =>
                  integration?.type === 'SmartSchankPeripheralIntegration',
              ) && (
                <>
                  <div className="d-flex justify-content-center align-items-center">
                    <div className="d-block">
                      {smartSchankAccessCode ? (
                        <QRCode size={100} value={smartSchankAccessCode} />
                      ) : (
                        <SkeletonLoader
                          inline
                          style={{ width: '100px', height: '100px' }}
                        />
                      )}
                    </div>
                    <span
                      style={{ fontSize: '40px' }}
                      className="px-1 ml-2 black"
                    >
                      {smartSchankAccessCode || (
                        <SkeletonLoader inline style={{ width: '100px' }} />
                      )}
                    </span>
                  </div>
                  <div className="d-flex text-center align-items-center mt-1">
                    <span className="px-1">
                      <FormattedMessage id="smartSchankQrCodeDescription" />
                    </span>
                  </div>
                  <hr />
                </>
              )}

            {/* List OrderItems */}
            {items?.map((orderItem, index) => (
              <OrderItemLine
                key={index}
                orderItem={orderItem}
                context="order"
              />
            ))}

            {[
              // addresses + cartComment section
              (billingAddress || deliveryAddress || cartComment) && ['hr'],
              deliveryAddress && [
                'deliveryAddress',
                deliveryAddressDescriptor,
                true,
              ],
              billingAddress && [
                'billingAddress',
                billingAddressDescriptor,
                true,
              ],
              cartComment && ['modalComment', cartComment, true],

              // customer information section
              (customerName || customerTel || customerEmail) && ['hr'],
              customerName && ['name', customerName, true],
              customerTel && ['tel', customerTel, true],
              customerEmail && ['email', customerEmail, true],

              // order information section
              ['hr'],
              checkoutMethod !== CHECKOUT_METHOD_PAY_AND_GO && [
                'orderNumber',
                number,
              ],
              checkoutMethod !== CHECKOUT_METHOD_ORDER_ONLY &&
                store?.merchantProfile?.posIntegration?.type ===
                  'HelloTessPosIntegration' && [
                  'invoiceNumber',
                  invoiceNumber || (
                    <SkeletonLoader inline style={{ width: '60px' }} />
                  ),
                ],
              checkoutMethod === CHECKOUT_METHOD_PAY_AND_GO
                ? [
                    'paidLabel',
                    <FormattedDate
                      value={statusPaidAt}
                      format="full2Digit"
                      second={undefined}
                    />,
                  ]
                : [
                    'orderedAt',
                    <FormattedDate
                      value={createdAt}
                      format="full2Digit"
                      second={undefined}
                    />,
                  ],
              /* Relative orderedAt
                  [
                    '',
                    <FormattedRelativeTime
                      value={calculateAgoSeconds(updatedAt)}
                      format="long"
                      updateIntervalInSeconds={calculateUpdateIntervalSeconds(
                        updatedAt,
                      )}
                    />,
                  ],*/
              table && [
                'inhouseOrderDestination',
                <FormattedMessage
                  id="table"
                  values={{ tableName: table?.name }}
                />,
              ],
              ['orderType', <FormattedMessage id={'orderType' + type} />],
              [
                'status',
                <FormattedMessage
                  id={
                    'orderStatus' +
                    capitalize(status) +
                    (isPendingOrderStatus(status) ? `Ago@${type}` : '')
                  }
                  values={{ ago: '' }}
                />,
              ],

              //
              (order?.pickupRequestedAt || order?.deliveryRequestedAt) && [
                order?.pickupRequestedAt
                  ? 'pickupRequestedAtLabel'
                  : 'deliveryRequestedAtLabel',
                <FormattedDate
                  value={order?.pickupRequestedAt || order?.deliveryRequestedAt}
                  format="full2Digit"
                  second={undefined}
                />,
              ],

              (order?.pickupConfirmedAt || order?.deliveryConfirmedAt) && [
                order?.pickupConfirmedAt
                  ? 'pickupConfirmedAtLabel'
                  : 'deliveryConfirmedAtLabel',
                <FormattedDate
                  value={order?.pickupConfirmedAt || order?.deliveryConfirmedAt}
                  format="full2Digit"
                  second={undefined}
                />,
              ],
            ]
              .filter(Boolean)
              .map(([id, content, isMarquee], index) =>
                id === 'hr' ? (
                  <hr />
                ) : (
                  <div key={index} className="d-flex align-items-center">
                    <span className="flex-grow-0 text-left pr-1">
                      <FormattedMessage id={id} values={{ orderNumber: '' }} />
                    </span>
                    <span className="flex-grow-1 text-right">
                      {isMarquee ? <Marquee>{content}</Marquee> : content}
                    </span>
                  </div>
                ),
              )}

            {!isAdminMode &&
              !kiosk &&
              merchantProfile?.allowUserChangeOrderStatusToCompleted &&
              status !== ORDER_STATUS_COMPLETED &&
              ((iAmHereNotificationAt &&
                merchantProfile?.enableIAmHereNotification) ||
                !merchantProfile?.enableIAmHereNotification ||
                ![ORDER_TYPE_PICKUP].includes(type)) &&
              [
                ORDER_TYPE_PICKUP,
                ORDER_TYPE_DELIVERY,
                ORDER_TYPE_SELF_SERVICE,
              ].includes(type) && (
                <>
                  <hr />
                  <DefaultAlert
                    color="warning"
                    msg={intl.formatMessage(
                      { id: 'swipeToCompleteOrderTitle' },
                      { storeName: store?.name },
                    )}
                  />
                  <div
                    style={{ touchAction: 'pan-y' }}
                    className="d-flex bg-white mt-1 justify-content-center"
                  >
                    <SwipeableButton
                      circle
                      onSuccess={handleOrderCompleted}
                      text={intl.formatMessage(
                        { id: 'swipeRightToCompleteOrderLabel' },
                        { storeName: store?.name },
                      )}
                    />
                  </div>
                </>
              )}
            {!isAdminMode &&
              merchantProfile.enableIAmHereNotification &&
              store?.merchantProfile?.posIntegration?.dummyItemRefs?.length >
                0 &&
              status !== ORDER_STATUS_COMPLETED &&
              !iAmHereNotificationAt &&
              [ORDER_TYPE_PICKUP].includes(type) && (
                <>
                  <hr />
                  <DefaultAlert
                    color="success"
                    msg={intl.formatMessage(
                      { id: 'swipeToNotifyStore' },
                      { storeName: store?.name },
                    )}
                  />

                  <div
                    style={{ touchAction: 'pan-y' }}
                    className="d-flex bg-white mt-1 justify-content-center"
                  >
                    <SwipeableButton
                      circle
                      onSuccess={handleNotifyStore}
                      text={intl.formatMessage(
                        { id: 'IAmHereLabel' },
                        { storeName: store?.name },
                      )}
                    />
                  </div>
                </>
              )}

            <hr />
            {[
              // prices and fees section
              isDeliveryOrder && [
                'deliveryFeeLabel',
                <FormattedNumber value={deliveryFee} format="priceCurrency" />,
              ],
              (isDeliveryOrder || isPickupOrder) &&
                serviceFee && [
                  'serviceFeeLabel',
                  <FormattedNumber value={serviceFee} format="priceCurrency" />,
                ],
              discountCode && [
                'discountCodeValueLabel',
                <FormattedNumber value={discount} format="priceCurrency" />,
              ],
              tip && [
                'tipTitle',
                <FormattedNumber value={tip} format="priceCurrency" />,
              ],
              [
                'totalLabel',
                <FormattedNumber value={total} format="priceCurrency" />,
              ],
            ]
              .filter(Boolean)
              .map(([id, content, isMarquee], index) => (
                <div
                  key={index}
                  className={classnames('d-flex align-items-center', {
                    black: id === 'totalLabel',
                  })}
                >
                  <span className="flex-grow-0 text-left pr-1">
                    <FormattedMessage
                      id={id}
                      values={{
                        orderNumber: '',
                        discountCode: discountCode?.code,
                      }}
                    />
                  </span>
                  <span className="flex-grow-1 text-right">
                    {isMarquee ? <Marquee>{content}</Marquee> : content}
                  </span>
                </div>
              ))}

            {taxesByType?.map(({ type, total }, index) => (
              <div key={index} className="d-flex align-items-center">
                <span className="flex-grow-0 text-left pr-1 font-small-3">
                  <FormattedMessage
                    id="orderTaxLabel"
                    values={{
                      percent: intl.formatNumber(type / 100, {
                        format: 'taxPercentage',
                      }),
                    }}
                  />
                </span>
                <span className="flex-grow-1 text-right font-small-3">
                  <FormattedNumber value={total} format="priceCurrency" />
                </span>
              </div>
            ))}

            {isAdminMode &&
              (ORDER_TYPE_PICKUP === type || ORDER_TYPE_DELIVERY === type) &&
              !(order?.pickupConfirmedAt || order?.deliveryConfirmedAt) && (
                <>
                  <FormattedMessage
                    id={
                      ORDER_TYPE_PICKUP === type
                        ? 'pickupConfirmedAtText'
                        : 'deliveryConfirmedAtText'
                    }
                    values={{ customerName: order?.customerName }}
                  />
                  <Row className="mt-2">
                    <Col xs="4" className="d-flex justify-content-center">
                      <Button
                        className="w-100"
                        color="primary"
                        onClick={(e) => {
                          e.preventDefault();
                          setExpectedMinutes(15, order);
                        }}
                      >
                        <FormattedNumber value={15} format="minutes" />
                      </Button>
                    </Col>
                    <Col xs="4" className="d-flex justify-content-center">
                      <Button
                        className="w-100"
                        color="primary"
                        onClick={(e) => {
                          e.preventDefault();
                          setExpectedMinutes(30, order);
                        }}
                      >
                        <FormattedNumber value={30} format="minutes" />
                      </Button>
                    </Col>
                    <Col xs="4" className="d-flex justify-content-center">
                      <Button
                        className="w-100"
                        color="primary"
                        onClick={(e) => {
                          e.preventDefault();
                          setExpectedMinutes(45, order);
                        }}
                      >
                        <FormattedNumber value={45} format="minutes" />
                      </Button>
                    </Col>
                  </Row>
                  <Row className="mt-1 pb-1">
                    <Col xs="4" className="d-flex justify-content-center">
                      <Button
                        className="w-100"
                        color="primary"
                        onClick={(e) => {
                          e.preventDefault();
                          setExpectedMinutes(60, order);
                        }}
                      >
                        <FormattedNumber value={60} format="minutes" />
                      </Button>
                    </Col>
                    <Col xs="4" className="d-flex justify-content-center">
                      <Button
                        className="w-100"
                        color="primary"
                        onClick={(e) => {
                          e.preventDefault();
                          setExpectedMinutes(75, order);
                        }}
                      >
                        <FormattedNumber value={75} format="minutes" />
                      </Button>
                    </Col>
                    <Col xs="4" className="d-flex justify-content-center">
                      <Button
                        className="w-100"
                        color="primary"
                        onClick={(e) => {
                          e.preventDefault();
                          setExpectedMinutes(90, order);
                        }}
                      >
                        <FormattedNumber value={90} format="minutes" />
                      </Button>
                    </Col>
                  </Row>
                </>
              )}
          </div>
        </>
      )}
    </ModalSheet>
  );
};

const mapStateToProps = (state) => ({
  isOpen: state.modals.isOrderInfoModalOpen,
  data: state.modals.orderInfoModalData,
  store: state.store.store,
  me: state.me.me,
  userOrders: state.me.orders,
  storeOrders: state.store.storeOrders,
  billingAddresses: state.me.billingAddresses,
  tableCart: state.store.tableCart,
  kiosk: state.store.kiosk,
});

export default connect(mapStateToProps, {
  setIsOrderInfoModalOpen,
  setOrderInfoModalData,
  setIsCreateBillingAddressModalOpen,
  setIsSelectBillingAddressModalOpen,
  setCreateBillingAddressModalData,
  setIsTableCartModalOpen,
  setSpecificOrder,
  setStoreSpecificOrder,
  fetchOnAuthenticated,
  fetchOrders,
  setFoodPreferencesFilter,
  setFoodIngredientsFilter,
  setFoodAllergensFilter,
  setIsOrderNotificationsModalOpen,
  fetchMeWithPromise,
  setOrderHintModalData,
  setIsOrderHintModalOpen,
})(OrderInfoModal);
